import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Array } from '@blade/std-lib'
import { Button } from '@blade/ui-kit'
import { ResetIcon } from '@root/shared/ui-kit'

import { TopbarPairItemSkeleton } from './topbar-pair-item-skeleton'

import type { ClassNameProps } from '@root/shared/react'

type InfoIntent = 'error' | 'empty'

type TopbarErrorProps = {
  onReload: () => void
  intent?: InfoIntent
} & ClassNameProps

export const TopbarError: React.FC<TopbarErrorProps> = ({
  className,
  intent,
  onReload,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <Background>
        {Array.range(1, 8).map((it) => (
          <TopbarPairItemSkeleton key={it} />
        ))}
      </Background>
      <InfoMessage>
        <Label>
          {t(
            intent === 'error'
              ? 'common.something-went-wrong'
              : 'common.no-items-found',
          )}
        </Label>
        <ResetButton
          size="xxs"
          variant="soft"
          onClick={onReload}
          iconLeft={<ResetIcon size={12} />}
          radius="rounded"
        >
          {t('common.reload')}
        </ResetButton>
      </InfoMessage>
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-10);
  overflow: hidden;

  font-size: 12px;
  font-weight: 500;
  text-align: center;

  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;

  gap: 10px;
  height: 24px;

  position: relative;
`
const Label = styled.div`
  white-space: nowrap;
`
const Background = styled.div`
  display: grid;
  grid-auto-flow: column;
  overflow: hidden;
  padding-inline-start: 6px;
  gap: 10px;
`

const ResetButton = styled(Button)`
  --button-radius-rounded: 6px;

  color: var(--text-12);
  font-size: 10px;
  font-weight: 500;
`

const InfoMessage = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;

  display: grid;
  gap: 8px;
  grid-template-columns: auto auto;
  align-items: center;

  background: var(--appearance-1);
  box-shadow: 0px 2px 35px 25px var(--appearanceA-6);
  padding: 0 20px;
`
